import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TouchableOpacity, View } from 'react-native';
import MyAppText from '../MyAppText';
import { faFile, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { MyImage } from '../MyImage';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { useStyles } from 'react-native-unistyles';
import { faArrowDownToSquare } from '@fortawesome/pro-regular-svg-icons';
import Tooltip from '../Tooltip';
import { translate } from '../../services/translate';

interface Props {
    file: File;
    onRemove: () => void;
    downloadable?: boolean;
    onDownload?: () => void;
}

export default function FilePreview({
    file,
    onRemove,
    downloadable,
    onDownload
}: Props) {
    const { theme } = useStyles();
    const isImage = file.type.startsWith('image/');
    const previewUrl = isImage ? URL.createObjectURL(file) : null;

    return (
        <View
            style={{
                width: 120,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: '#444',
                overflow: 'visible',
                position: 'relative',
            }}
        >

            <TouchableOpacity
                onPress={onRemove}
                style={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    zIndex: 10,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    borderRadius: 12,
                    width: 22,
                    height: 22,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <FontAwesomeIcon icon={faXmark as IconDefinition} color="#fff" />
            </TouchableOpacity>

            {downloadable && <TouchableOpacity
                onPress={onDownload}
                style={{
                    position: 'absolute',
                    top: 4,
                    left: 4,
                    zIndex: 99999,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    borderRadius: 12,
                    width: 22,
                    height: 22,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Tooltip
                    useSimpleBox
                    tooltipDirection='top'
                    tooltipContent={translate('download')}
                    style={{
                        color: theme.colors.white['500'],
                        padding: 8,
                        borderRadius: 8,
                        justifyContent: 'center',
                        zIndex: 9999,
                        top: 20,
                        width: 'auto',
                        fontSize: 12,
                        background: theme.colors.neutral['500'],
                    }}
                >
                    <FontAwesomeIcon icon={faArrowDownToSquare as IconDefinition} color="#fff" fontSize={11} />
                </Tooltip>
            </TouchableOpacity>
            }

            {isImage ? (
                <MyImage
                    imageUrl={previewUrl!}
                    style={{ width: '100%', height: 80, objectFit: 'cover' }}
                />
            ) : (
                <View
                    style={{
                        height: 80,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <FontAwesomeIcon
                        icon={faFile as IconDefinition}
                        color={theme.colors.iconColor}
                        fontSize={32}
                    />
                </View>
            )}

            <View style={{ padding: 6 }}>
                <MyAppText
                    style={{ fontSize: 11 }}
                    numberOfLines={2}
                >
                    {file.name}
                </MyAppText>
            </View>
        </View>
    );
}
